import { basicFilterInitialState } from '../../../../../stateManagement/reduxUtil';
import { commonTypes } from '../../../../common/redux/actions/commonActions';
import { genEditActionTypes } from '../actions/actionTypes';
import { updateFilterReducer, updateTableConfig } from './utilities/utility';

export const REDUCER_NAME = 'GenEditTypeFilterList';

const logErrListReq = (state, action) => ({
  ...state,
  listRequest: action.data ? action.data : state.listRequest,
  listRequestedOn: new Date(),
  loading: true,
});

const getEditItemDetailsResponse = (state, action) => ({
  ...state,
  getEditItemDetails: action.data,
});
const resetServerValue = (state, action) => ({
  ...state,
  serverRequestError: action.data && action.data.serverRequestError,
  loading: false,
});
const genEditTypeFilterListConfig = (state = { ...basicFilterInitialState }, action = null) => {
  switch (action.type) {
    // config list column configuration
    case genEditActionTypes.UPDATE_GET_FILTER_CONFIG:
      return {
        ...state,
        ...updateFilterReducer(action),
      };
    case genEditActionTypes.REMOVE_GET_USER_DEFAULT_FILTER:
      return {
        ...state,
        userDefaultFilter: null,
      };
    case genEditActionTypes.UPDATE_GET_COLUMN_CONFIG:
      return {
        ...state,
        listSortOptions: action.data.sortOptions,
        listColumnOrder: action.data.columnOrder,
        listGroupBy: action.data ? action.data.detail.groupByParameters : null,
        isDistinctActive: action.data ? action.data.detail.isDistinct : null,
      };
    default:
      return null;
  }
};

const genEditTypeFilterListREQRES = (state = { ...basicFilterInitialState }, action = null) => {
  switch (action.type) {
    // log request
    case genEditActionTypes.LOG_GET_LIST_REQUEST:
      return logErrListReq(state, action);
    // log error
    case genEditActionTypes.GET_GET_LIST_ERROR:
      return {
        ...state,
        listRequestError: action.data,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    // store response
    case genEditActionTypes.GET_GET_LIST_RESPONSE:
      return {
        ...state,
        listData: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case genEditActionTypes.GET_GET_BY_ID_RESPONSE:
      return getEditItemDetailsResponse(state, action);
    case genEditActionTypes.RESET_GET_STORE:
      return {
        ...state,
        listData: null,
        listRequestError: null,
        listRequestProcessedOn: null,
        serverRequestError: null,
        loading: false,
      };
    case genEditActionTypes.UPDATE_TABLE_CONFIGURATION:
      return updateTableConfig(state, action);
    case genEditActionTypes.GET_DEPENDENCY_EXIST_RESPONSE:
      return {
        ...state,
        DependencyExist: action.data,
        listRequestError: null,
        listRequestProcessedOn: new Date(),
        loading: false,
      };
    case genEditActionTypes.RESET_SERVER_VALUE:
      return resetServerValue(state, action);
    case commonTypes.RESETSTORE:
      return basicFilterInitialState;
    default:
      return null;
  }
};

const GenEditTypeFilterList = (state = { ...basicFilterInitialState }, action = null) => {
  const stateConfig = genEditTypeFilterListConfig(state, action);
  const stateReqRes = genEditTypeFilterListREQRES(state, action);
  if (stateConfig !== null) {
    return stateConfig;
  }
  if (stateReqRes !== null) {
    return stateReqRes;
  }
  return state;
};

export default GenEditTypeFilterList;
